module.exports = __webpack_public_path__ + "static/media/thumb-up.a38f0888.png";